// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","FooterGithub":"Footer_FooterGithub__2GdkA"};